import { baseInstance } from './base-instance';
import { setupInterceptors } from './interceptors';
import { config } from '../env-helpers';
import axios from 'axios';

export const AxiosDocumentDownloadInstance = axios.create({
  ...baseInstance.defaults,
  baseURL: config.DOCUMENT_DOWNLOAD_ENDPOINT,
  responseType: 'blob',
});

setupInterceptors(AxiosDocumentDownloadInstance);
